/**************************************************************
 Copyright © Sogu Technologies Co. Ltd 2018-2050 All rights reserved.
 File name: footer
 Author: HuangJun
 Description: 页面底部
 Others: 
 History: 
     1.Date:
       Author: 
       Modification:
*******************************************************************/
<template>
  <div>
    <div class="footer flex align-item-center ">
      <span style="font-size: 25px;color: #fff; ">劳动力管理专家，让人力更简单</span>
      <!-- <img class="footer_logo" src="../assets/img/footer_logo.png" alt /> -->
      <p class="copyright"><a target="_blank" href="https://wap.scjgj.sh.gov.cn/businessCheck/verifKey.do?showType=extShow&serial=9031000020231204091659000011417523-SAIC_SHOW_310000-2c984b428a0650a9018a32e766195006606&signData=MEUCICC6sFo8XcpdYey02MDGiI7ZTyd/MtEApuUapZE5HqusAiEAlKIB+p88gguxDf5ev1U/+AV3ofTuuwQhfeOTjzz10uo="><img src="../assets/lz2.jpg" alt="" style="width: 30px;height: 30px; float: left;margin-right: 5px;" class=" align-item-center ">上海效冠信息科技有限公司</a> &nbsp;&nbsp;&nbsp;&nbsp;ICP备案号: <a href="https://beian.miit.gov.cn/?spm=5176.13841030.J_9220772140.116.71fe6fc4nMG2YY#/Integrated/index" target="_blank" rel="noopener noreferrer">沪ICP备2023013121号-6</a></p>
      <!-- <p class="copyright">上海效冠信息科技有限公司 &nbsp;&nbsp;&nbsp;&nbsp;ICP备案号: <a href="https://beian.miit.gov.cn/?spm=5176.13841030.J_9220772140.116.71fe6fc4nMG2YY#/Integrated/index" target="_blank" rel="noopener noreferrer">沪ICP备2023013121号-6</a></p> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted: function() {},
  computed: {},
  methods: {
    
  }
};
</script>



// WEBPACK FOOTER //
// src/components/footer.vue